import FaceRecognition from "@/components/FaceRecognition";

export default function FaceRecognitionPage() {
  return <FaceRecognition />;
}
